/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Create a custom task
 */
export type TaskCreateRequest = {
    /**
     * Task title (1–255 chars)
     */
    title: string;
    /**
     * Optional free-text details
     */
    description?: string | null;
    /**
     * Initial workflow state
     */
    status?: TaskCreateRequest.status;
};
export namespace TaskCreateRequest {
    /**
     * Initial workflow state
     */
    export enum status {
        OPEN = 'open',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        DISMISSED = 'dismissed',
    }
}

